import { useSelector } from 'react-redux';

type RootState = { storeService: { ready: boolean } };
const rootSelector = (state: RootState) => state.storeService;
export const useStoreIsReady = () => useSelector(rootSelector).ready;
